import { host } from "~/utils/constants";
import {Category} from "~/utils/Category";
import {Article} from "~/utils/Article";
import { useUserDataStorage } from "~/store/userdata";

export class Product {
  id = 0;
  Name = "";
  Price = 0.0;
  Images: string[] = [];
  Description = "";
  categories: Category[] = []
  articles: Article[] = []
  manualUrl: string = ""
  type: "rental"|"sale" = "rental"
  showPrice: "admin"|"customer"|"public" = "admin"

  parseJson(ret: { id: number; attributes: { [key: string]: any } }) {
    this.id = ret.id;
    this.Name = ret.attributes.Name;
    this.Price = ret.attributes.Price;
    this.Description = ret.attributes.Description;
    this.type = ret.attributes.type ? ret.attributes.type : "rental";
    this.showPrice = ret.attributes.showPrice ? ret.attributes.showPrice : "admin"
    if(ret.attributes.Images){
      this.Images = []
      if(ret.attributes.Images.data){
        ret.attributes.Images.data.forEach((image:any) => {
          this.Images.push(host + image.attributes.url);
        });
      }
      else{
        this.Images.push(host + "/uploads/wp_content_uploads_woocommerce_placeholder_200x200_b408feaf06_e439d49102.png")
      }
    }
    if(ret.attributes.categories){
      this.categories = []
      ret.attributes.categories.data.forEach((category:any) => {
        const tempCategory = new Category()
        tempCategory.parseJson(category)
        this.categories.push(tempCategory);
      });
    }
    if(ret.attributes.articles){
      this.articles = []
      ret.attributes.articles.data.forEach((article:any) => {
        const tempArticle = new Article()
        tempArticle.parseJson(article)
        this.articles.push(tempArticle);
      });
    }
    if(ret.attributes.manual && ret.attributes.manual.data){
      this.manualUrl = host + ret.attributes.manual.data.attributes.url
    }
  }
  toJSON () {
    const retValue = {...this}
    const optimizedCategories:{id:number, name:String}[] = []
    if(retValue.categories){
      retValue.categories.forEach((category)=>{
        optimizedCategories.push({
          "id":category.id,
          "name":category.name
        })
      })
    }
    retValue.categories = optimizedCategories as Category[]
    retValue.articles = []
    return retValue
  }
}

export function isPriceOfProductVisible(product:Product){
  let priceVisible = false
  const userDataStorage = useUserDataStorage()

  if(userDataStorage.user){
    if(userDataStorage.user.role.name == "Authenticated"){
      priceVisible = true
    }
    if(userDataStorage.user.role.name == "Customer" && product.showPrice == "customer"){
      priceVisible = true
    }
  }
  if(product.showPrice == "public"){
    priceVisible = true
  }

  return priceVisible
}
